import { getMetricById } from '../../service/reports'

const defaultState = {
  metric: {
    group_name: undefined,
    group_id: undefined,
    metric_id: undefined,
    date: undefined,
    label: undefined,
    title: undefined,
    subtitle: undefined,
    description: undefined,
    score: undefined,
    submetrics: [],
    history: [],
  },
}

const state = {
  metric: Object.create(defaultState),
}

const getters = {
  metric: state => state.metric,
}

const actions = {
  requestMetric({ commit }, { groupId, metricId }) {
    return getMetricById(metricId, groupId).then(metric =>
      commit('setMetric', metric)
    )
  },

  updateMetricData({ commit }, metric) {
    commit('setMetric', metric)
  },

  resetMetricState({ commit }) {
    commit('setMetric', defaultState)
  },
}

const mutations = {
  setMetric(state, metric) {
    state.metric = metric
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
}
